<template>
	<div>
		
		<template v-if="!disabled && !readonly && !renderCell">
			<el-select :value="value" :clearable="clearable" :size="size" :multiple="islist || multiple"
				:placeholder="placeholder" :disabled="disabled" @change="change" :collapse-tags="collapseTags" filterable>
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<div class="full" @click="modal" v-if="!disabled && !readonly && ismodal" style="z-index: 999;"></div>
		</template>
		<template v-else>
			<span v-if="renderCell">{{valuetext}}</span>
			<el-input v-else v-model="valuetext" :disabled="disabled" :readonly="readonly" :size="size"></el-input>
		</template>


		<staff-modal :islist="islist" :multiple="multiple" :staffid="staffid" ref="staffModal" @submit="submit" />
<!-- 		<vxe-modal v-model="modalShow" destroy-on-close :width="800" :height="800" show-footer @show="show" @hide="hide"
			transfer :lock-scroll="false">
			<template #title>
				<div>选择人员</div>
			</template>
			<template #default>
				<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
					<el-tab-pane label="人员" name="modalStaff">
						<modalStaff :staffid="staffid" :multiple="islist || multiple" ref="modalStaff" />
					</el-tab-pane>
				</el-tabs>
				<transition name="el-fade-in-linear">
					<div class="full flex form_loading" v-if="loading"
						style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
						<i class="vxe-icon-refresh roll"></i>
						<span>正在加载</span>
					</div>
				</transition>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal> -->
	</div>
</template>
<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	
	import staffModal from '@_system/components/formcomponents/common/select/staff/modal/staff.vue'
	export default {
		mixins: [selectBase],
		props: {
			ismodal: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				staffid: [],
				ready: false,
				options: [],
				sourceData: [],
				store: {},
				fApi: {},
				modalShow: false,
				loading: false,
				valuetext: ''
			}
		},
		created() {
			this.init()
			this.getValuetext(this.value)
			// console.log(this.renderCell)
		},
		watch: {
			value(value) {
				this.getValuetext(value)
				this.change(value)
			},
			renderCell(){
				// console.log(e)
			}
		},
		computed: {

		},
		methods: {
			setSelf() {
				let field = this.formCreateInject.field
				let value = this.formCreateInject.api.myformOption.$store.state.system.user.id
				this.formCreateInject.api.setValue(field, value)
			},
			getValuetext(value) {
				this.valuetext = null
				this.options.forEach((item) => {
					if (item.value == value) {
						this.valuetext = item.label
					}
				})
			},
			list() {
				if (!window.systemData.staff) {
					this.$api.staff.list({
						currentPage: -1
					}).then((res) => {
						let options = []
						res.list.forEach((item) => {
							options.push({
								value: item.id,
								label: item.name,
								status: item.status,
								enable: item.enable,
								departmentid: item.departmentid
							})
						})
						this.options = options
						this.finish()
					})
				} else {
					let list = JSON.parse(JSON.stringify(window.systemData.staff))
					let options = []
					list.forEach((item) => {
						options.push({
							value: item.id,
							label: item.name,
							status: item.status,
							enable: item.enable,
							departmentid: item.departmentid
						})
					})
					this.options = options
					this.finish()
				}
				
			},
			init() {


			},
			show() {

			},
			hide() {
				this.loading = false
				this.back()
			},
			handleClick() {

			},
			submit(e) {
				let value = null
				let data = e.data
				//console.log(e,123123)
				if (data.length != 0) {
					if (this.islist || this.multiple) {
						value = data.map((item) => {
							return item.id
						})
					} else {
						value = data[0].id
					}
				}
				if (this.formCreateInject) {
					let field = this.formCreateInject.field
					this.formCreateInject.api.setValue(field, value)
					this.relationdepertment(field,value,'form')
				}else if (this.tableFormInfo) {
					this.tableFormInfo.$form.data[this.tableFormInfo.field] = value
				}else if (this.row && this.column) {
					this.row[this.column.field] = value
					this.relationdepertment(this.column.field,value,'table')
				}
				this.$emit('modalsubmit', {
					data: value
				})
				//this.back()
				//console.log(data,this.formCreateInject)	
			},
			relationdepertment(field,value,type){
				if(field.endsWith('staffid')){
					let staffinfo = window.systemData.staff.find((item)=>{
						return item.id == value
					})
					if(staffinfo){
						let departmentfield = field.replace('staffid','departmentid')
						if(type == 'form'){
							this.formCreateInject.api.setValue(departmentfield, staffinfo.departmentid)
						}
						if(type == 'table'){
							this.row[departmentfield] = staffinfo.departmentid
						}	
					}
				}
			},
			modal() {
				let arr = []
				arr.push(this.value)
				this.staffid = arr
				this.$refs.staffModal.modal_show()

			}
		},
		components: {
			staffModal
		}
	}
</script>
